@if (visible) {
    <div class="quick-chat-call-backdrop">
        <div class="quick-chat-call-window">
            <div class="quick-chat-call-topbar">
                <div class="min-w-0">
                    <div class="quick-chat-call-title">{{ title }}</div>
                    <div class="quick-chat-call-subtitle">
                        {{ contactName || 'Contact' }} - {{ statusLabel }}
                    </div>
                </div>

                <button mat-icon-button type="button" (click)="dismiss()" aria-label="Fermer l'appel">
                    <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                </button>
            </div>

            <div class="quick-chat-call-stage" [ngClass]="{ 'quick-chat-call-stage-audio': mediaType === 'audio' }">
                <video
                    #remoteVideo
                    class="quick-chat-call-remote-video"
                    autoplay
                    playsinline
                ></video>

                @if (callState !== 'incoming') {
                    <div class="quick-chat-call-stage-actions">
                        @if (mediaType === 'video') {
                            <button
                                class="quick-chat-call-stage-action"
                                type="button"
                                [class.quick-chat-call-stage-action-off]="isScreenSharing"
                                [attr.aria-pressed]="isScreenSharing"
                                [attr.aria-label]="isScreenSharing ? 'Arrêter le partage d’écran' : 'Partager l’écran'"
                                [attr.title]="isScreenSharing ? 'Arrêter le partage d’écran' : 'Partager l’écran'"
                                (click)="toggleScreenShare()"
                            >
                                <mat-icon>{{ isScreenSharing ? 'stop_screen_share' : 'present_to_all' }}</mat-icon>
                            </button>
                        }

                        <button
                            class="quick-chat-call-stage-action"
                            type="button"
                            [class.quick-chat-call-stage-action-off]="!webrtcService.isMicrophoneEnabled()"
                            [attr.aria-pressed]="webrtcService.isMicrophoneEnabled()"
                            [attr.aria-label]="webrtcService.isMicrophoneEnabled() ? 'Désactiver le micro' : 'Activer le micro'"
                            [attr.title]="webrtcService.isMicrophoneEnabled() ? 'Désactiver le micro' : 'Activer le micro'"
                            (click)="toggleMicrophone()"
                        >
                            <mat-icon>{{ webrtcService.isMicrophoneEnabled() ? 'mic' : 'mic_off' }}</mat-icon>
                        </button>

                        <button
                            class="quick-chat-call-stage-action"
                            type="button"
                            [class.quick-chat-call-stage-action-off]="!webrtcService.isCameraEnabled()"
                            [attr.aria-pressed]="webrtcService.isCameraEnabled()"
                            [attr.aria-label]="webrtcService.isCameraEnabled() ? 'Désactiver la caméra' : 'Activer la caméra'"
                            [attr.title]="webrtcService.isCameraEnabled() ? 'Désactiver la caméra' : 'Activer la caméra'"
                            (click)="toggleCamera()"
                        >
                            <mat-icon>{{ webrtcService.isCameraEnabled() ? 'videocam' : 'videocam_off' }}</mat-icon>
                        </button>
                    </div>
                }

                @if (!hasRemoteStream) {
                    <div class="quick-chat-call-waiting">
                        <div class="quick-chat-call-avatar quick-chat-call-avatar-large">
                            <mat-icon [svgIcon]="mediaType === 'video' ? 'heroicons_outline:video-camera' : 'heroicons_outline:phone'"></mat-icon>
                        </div>
                        <div class="quick-chat-call-waiting-title">{{ contactName || 'Contact' }}</div>
                        <div class="quick-chat-call-waiting-text">{{ statusLabel }}</div>
                    </div>
                }

                @if (mediaType === 'video' && hasLocalStream) {
                    <div class="quick-chat-call-local-preview">
                        <video
                            #localVideo
                            autoplay
                            muted
                            playsinline
                        ></video>
                        @if (isScreenSharing) {
                            <div class="quick-chat-call-local-preview-badge">Partage d'écran</div>
                        }
                    </div>
                }
            </div>

            @if (errorMessage) {
                <div class="quick-chat-call-error">
                    <mat-icon [svgIcon]="'heroicons_outline:exclamation-triangle'"></mat-icon>
                    <span>{{ errorMessage }}</span>
                </div>
            }

            <div class="quick-chat-call-controls">
                @if (callState === 'incoming') {
                    <button
                        class="quick-chat-call-control quick-chat-call-accept"
                        mat-fab
                        type="button"
                        aria-label="Accepter l'appel"
                        (click)="acceptIncomingCall()"
                    >
                        <mat-icon [svgIcon]="'heroicons_outline:phone'"></mat-icon>
                    </button>
                    <button
                        class="quick-chat-call-control quick-chat-call-end"
                        mat-fab
                        type="button"
                        aria-label="Refuser l'appel"
                        (click)="rejectIncomingCall()"
                    >
                        <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                    </button>
                } @else {
                    <button
                        class="quick-chat-call-control quick-chat-call-end"
                        mat-fab
                        type="button"
                        aria-label="Raccrocher"
                        (click)="endCall()"
                    >
                        <mat-icon [svgIcon]="'heroicons_outline:phone-x-mark'"></mat-icon>
                    </button>
                }
            </div>
        </div>
    </div>
}
